module.exports = __webpack_public_path__ + "static/media/elk_dnd_2.ae1a8885.jpg";